export default [
    {
        meta: {
            privada: false,
            titulo: 'Iniciar sesión'
        },
        path: '/',
        name: 'login',
        component: () => import(/* webpackChunkName: "main" */ './views/login/login.vue'),
    },
    {
        meta: {
            privada: false,
            titulo: 'Restablecer clave'
        },
        path: '/clave',
        name: 'clave',
        component: () => import(/* webpackChunkName: "main" */ './views/login/clave.vue'),
    },
    {
        meta: {
            privada: false,
            titulo: 'Restablecer clave'
        },
        path: '/crear-clave',
        name: 'crear_clave',
        component: () => import(/* webpackChunkName: "main" */ './views/login/crear_clave.vue'),
    },
    {
        meta: {
            privada: false,
            titulo: 'Restablecer clave'
        },
        path: '/restablecer-clave',
        name: 'restablecer_clave',
        component: () => import(/* webpackChunkName: "main" */ './views/login/restablecer_clave.vue'),
    },
    {
        meta: {
            privada: true,
            titulo: 'Dashboard'
        },
        path: '/dashboard',
        name: 'dashboard',
        component: () => import(/* webpackChunkName: "main" */ './views/dashboard.vue'),
    },
    {
        meta: {
            privada: true,
            titulo: 'Notificaciones'
        },
        path: '/notificaciones/',
        name: 'notificaciones',
        component: () => import(/* webpackChunkName: "notificaciones" */ './views/notificaciones/notificaciones.vue')
    },
    {
        meta: {
            privada: true,
            titulo: 'Fechas de entrega'
        },
        path: '/fechas',
        name: 'fechas',
        component: () => import(/* webpackChunkName: "fechas" */ './views/fechas/fechas.vue')
    },
]
